module.exports = __webpack_public_path__ + "img/patho-unknown-H.0df14771.svg";